import React from "react";
import Header from "../../components/HeaderGreen";
import Footer from "../../components/Footer";
import GreenBanner from "../../components/GreenBanner";
import RecentProjects from "../../components/Home/RecentProjects";
import ContactSection from "../../components/ContactSection";
import RenewableEnergySection from "../../components/GreenEnergy/RenewableEnergySection";
import PreferredEnergy from "../../components/GreenEnergy/PreferredEnergy";
import SaveSection from "../../components/GreenEnergy/SaveSection";

function Home() {
  return (
    <>
      <Header />
      <GreenBanner />
      <RenewableEnergySection />
      <PreferredEnergy />
      <SaveSection />
      <RecentProjects />
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
